import React from "react";
import { Label } from "reactstrap";
import { Container, Form, Row, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

const SelectCriteriaForm = (props) => {
  const {
    months,
    selectedMonth,
    onMonthChange,
    years,
    selectedYear,
    onYearChange,
  } = props;
  return (
    <Container fluid className="p-0 my-4">
      <Form>
        <Label className="select-criteria-form-title">Select Criteria</Label>

        <Row className="container-row-one">
          <Col lg={12}>
            <Row>
              {/* Month*/}
              <Col lg={4}>
                <Form.Group className="d-flex align-items-center m-0">
                  <Form.Label className="label mb-0 mr-5">Month</Form.Label>
                  <CustomReactSelect
                    className="dropDown ml-0"
                    options={months}
                    value={selectedMonth}
                    onChange={(value) => onMonthChange(value)}
                  />
                </Form.Group>
              </Col>

              {/* Year*/}
              <Col lg={4}>
                <Form.Group className="d-flex align-items-center m-0">
                  <Form.Label className="label mb-0 mr-5">Year</Form.Label>
                  <CustomReactSelect
                    className="dropDown ml-0"
                    options={years}
                    value={selectedYear}
                    onChange={(value) => onYearChange(value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default SelectCriteriaForm;
